import { render, staticRenderFns } from "./SideNavigationMenu.vue?vue&type=template&id=578a8ca8&scoped=true&"
import script from "./SideNavigationMenu.vue?vue&type=script&lang=js&"
export * from "./SideNavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigationMenu.vue?vue&type=style&index=0&id=578a8ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a8ca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle})
